import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classnames from 'classnames';
import { CountdownUnit } from './CountdownUnit';
import styles from './Countdown.module.scss';
const MS_MINUTE = 60_000; // 60 * 1000
const MS_HOUR = 3_600_000; // 60 * 1000 * 60
const MS_DAY = 86_400_000; // 60 * 1000 * 60 * 24
const Countdown = ({ className, color, countdownUnits, isWide, msCountdown, text, }) => {
    const [msLeft, setMsLeft] = useState(msCountdown && msCountdown >= 0 ? msCountdown : 0);
    const daysLeft = Math.floor(msLeft / MS_DAY);
    const hoursLeft = Math.floor((msLeft % MS_DAY) / MS_HOUR);
    const minutesLeft = Math.floor((msLeft % MS_HOUR) / MS_MINUTE);
    const secondsLeft = Math.floor((msLeft % MS_MINUTE) / 1_000);
    useEffect(() => {
        const countdownInterval = setInterval(() => {
            setMsLeft(prevState => {
                if (prevState <= 1_000) {
                    clearInterval(countdownInterval);
                    return 0;
                }
                return prevState - 1_000;
            });
        }, 1_000);
        return () => clearInterval(countdownInterval);
    }, []);
    return (_jsxs("div", { className: classnames('d-flex justify-content-center text-center w-100 p-2x', styles.countdownWrapper, {
            'justify-content-between': !isWide,
            [styles.isWide]: isWide,
        }, className), style: { color }, children: [isWide && _jsx("div", { className: classnames(styles.textContainer, 'mr-10x'), children: text }), _jsxs("div", { className: classnames('d-flex justify-content-between', styles.counterContainer, {
                    'w-100': !isWide,
                }), children: [_jsx(CountdownUnit, { label: countdownUnits.days, value: daysLeft }), _jsx(CountdownUnit, { label: countdownUnits.hours, value: hoursLeft }), _jsx(CountdownUnit, { label: countdownUnits.minutes, value: minutesLeft }), _jsx(CountdownUnit, { label: countdownUnits.seconds, value: secondsLeft })] })] }));
};
export { Countdown };
